// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-light: #f4f9ff;
  --color-white: #ffffff;
  --color-primary: #1f68d6;
  --color-primary-2: #3b7ee3;
  --color-primary-3: #ccedff;
  --color-primary-4: #003c97;
  --color-primary-7: #c1daff;
  --color-primary-8: #97c1ff;
  --color-primary-9: #CCEDFF;
  --color-primary-10: #A8E1AE;
  --color-primary-11: #a1c4f9;
  --color-primary-12: #F5F5F5;
  --color-light-2: #E0E0E0;
  --color-error: #e12f2f;
  --color-success: #66b032;
  --color-green: #569755;
  --color-green-2: #92e391;
  --color-green-3: #d3eace;
  --color-yellow: #e7d788;
  --color-yellow-2: #ffc247;
  --color-yellow-3: #8f4f00;
  --color-light-red: #FFE8E8;
  --color-deep-red: #9f0000;
  --color-red: #c43c2d;
  --color-red-2: #af2415;
  --color-grey: #b3b3c5;
  --color-grey-2: #9898AB;
  --color-grey-3: #e0e9f3;
  --color-grey-4: #D1D1D1;
  --color-grey-5: #EBEBF5;
  --color-table-grey: #fafafc;
  --color-table-grey-1: #f4f4fc;
  --color-dark: #4a4a68;
  --color-dark-2: #1a1a42;
  --color-dark-3: #696365;
  --color-dark-4: #60607A;
  --color-dark-6: #2a2828;
  --color-admin: #112855;
  --color-admin-2: #071530;
  --color-admin-3: #020710;
  --color-disabled: #C0C0C0;
  --color-light-blue: #EBF2FF;
  --color-light-blue-2: #D4E5FF;
  --color-light-blue-3: #E7F3FE;
  --color-dark-yellow: #7E6E1F;
  --color-light-brown: #f4f5f6;
  --color-light-green: #E4FFEC;
  --color-light-yellow: #FFF5D7;
  --color-light-grey: #F3F3FF;
  --color-sell-main: #001432;
  --color-sell-2: #5F5F61;
  --color-moneyex-primary: #25C900;
  --color-moneyex-primary-2: #6bf04d;
  --color-moneyex-primary-3: #305627;
  --color-moneyex-primary-4: #0a2404;
  --default-font-size: 1.8rem;
  --default-font-h1: 6.4rem;
  --default-font-h2: 4rem;
  --default-font-h3: 3.2rem;
  --default-font-subtitle: 2.4rem;
  --default-font-medium: 1.6rem;
  --default-font-small: 1.4rem;
  --default-font-xsmall: 1.2rem;
}

.MimaNewFilter_filter__ieVbl {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
  font-size: var(--default-font-small);
  position: relative;
  z-index: 10;
}
.MimaNewFilter_filter__ieVbl > * {
  margin-bottom: 2rem;
}
.MimaNewFilter_filter__beside__nlElD {
  display: flex;
  gap: 1rem;
  position: absolute;
  top: 3rem;
  left: 1rem;
}
.MimaNewFilter_filter__by__TpDNG {
  background-color: var(--color-white);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  border-radius: 1rem;
  padding: 0 1rem;
  padding-bottom: 1rem;
  height: fit-content;
  color: var(--color-dark);
}
.MimaNewFilter_filter__by__list__i\\+wiP {
  padding: 1rem 2rem;
  list-style: none;
  cursor: pointer;
}
.MimaNewFilter_filter__by__list__i\\+wiP:hover {
  background-color: var(--color-grey-3);
  border-radius: 1rem;
}
.MimaNewFilter_filter__by__list__active__DiuYB {
  background-color: var(--color-grey-3);
  border-radius: 1rem;
}
.MimaNewFilter_filter__action__TvFi5 {
  background-color: var(--color-white);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  border-radius: 1rem;
  width: 30rem;
  padding: 2rem;
  display: flex;
  flex-direction: column;
}
.MimaNewFilter_filter__action__TvFi5 > :not(:last-child) {
  margin-bottom: 1rem;
}
.MimaNewFilter_filter__action__btns__yiayd {
  display: flex;
  gap: 1rem;
}

.MimaNewFilter_tag__2k1ha {
  background-color: var(--color-primary-3);
  font-size: var(--default-font-small);
  height: 4rem;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  width: 15rem;
  margin-top: 1rem;
  margin-right: 1rem;
}
.MimaNewFilter_tag_close__bc4Sb {
  display: block;
  background-color: var(--color-dark);
  color: var(--color-white);
  width: 16px;
  height: 16px;
  line-height: 16px;
  text-align: center;
  border-radius: 50%;
}

.MimaNewFilter_tags__ARQZT {
  display: flex;
  flex-wrap: wrap;
}
.MimaNewFilter_tags__ARQZT > :not(:last-child) {
  margin-right: 1rem;
}

.MimaNewFilter_singleTag__KOa0y {
  display: flex;
  font-size: var(--default-font-small);
  align-items: center;
  background-color: var(--color-grey-5);
  padding: 1rem;
  border-radius: 0.5rem;
  cursor: pointer;
  margin-bottom: 0.5rem;
}
.MimaNewFilter_singleTag__KOa0y > :not(:last-child) {
  margin-right: 0.5rem;
}
.MimaNewFilter_singleTag__KOa0y > :last-child {
  font-size: 2rem;
}
.MimaNewFilter_singleTag__KOa0y:hover {
  color: var(--color-primary);
}

.MimaNewFilter_tagRelative__R04cG {
  position: relative;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/variables/_variables.scss","webpack://./src/assets/styles/MimaFilter/MimaNewFilter.module.scss"],"names":[],"mappings":"AAAA;EAEC,sBAAA;EACA,sBAAA;EAEA,wBAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,wBAAA;EAGA,sBAAA;EACA,wBAAA;EACA,sBAAA;EACA,wBAAA;EACA,wBAAA;EACA,uBAAA;EACA,yBAAA;EACA,yBAAA;EACA,0BAAA;EACA,yBAAA;EACA,oBAAA;EACA,sBAAA;EAEA,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,2BAAA;EACA,6BAAA;EAEA,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EAEA,sBAAA;EACA,wBAAA;EACA,wBAAA;EAEA,yBAAA;EACA,2BAAA;EACA,6BAAA;EACA,6BAAA;EAEA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;EACA,2BAAA;EACA,0BAAA;EACA,uBAAA;EAEA,gCAAA;EACA,kCAAA;EACA,kCAAA;EACA,kCAAA;EAKA,2BAAA;EACA,yBAAA;EACA,uBAAA;EACA,yBAAA;EACA,+BAAA;EACA,6BAAA;EACA,4BAAA;EACA,6BAAA;ACbD;;AA9DA;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,oCAAA;EACA,kBAAA;EACA,WAAA;AAiED;AA/DC;EACC,mBAAA;AAiEF;AA9DC;EACC,aAAA;EACA,SAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AAgEF;AAzDC;EACC,oCAAA;EACA,4CAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EAEA,mBAAA;EACA,wBAAA;AA0DF;AAxDE;EACC,kBAAA;EACA,gBAAA;EACA,eAAA;AA0DH;AAxDG;EACC,qCAAA;EACA,mBAAA;AA0DJ;AAvDG;EACC,qCAAA;EACA,mBAAA;AAyDJ;AAlDC;EACC,oCAAA;EACA,4CAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AAoDF;AAlDE;EACC,mBAAA;AAoDH;AAjDE;EACC,aAAA;EACA,SAAA;AAmDH;;AA7CA;EACC,wCAAA;EACA,oCAAA;EACA,YAAA;EACA,oBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AAgDD;AA9CC;EACC,cAAA;EACA,mCAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AAgDF;;AA5CA;EACC,aAAA;EACA,eAAA;AA+CD;AA7CC;EACC,kBAAA;AA+CF;;AA3CA;EACC,aAAA;EACA,oCAAA;EACA,mBAAA;EACA,qCAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;EACA,qBAAA;AA8CD;AA5CC;EACC,oBAAA;AA8CF;AA3CC;EACC,eAAA;AA6CF;AA1CC;EACC,2BAAA;AA4CF;;AAvCA;EACC,kBAAA;AA0CD","sourcesContent":[":root {\n\t//COLORS\n\t--color-light: #f4f9ff;\n\t--color-white: #ffffff;\n\n\t--color-primary: #1f68d6;\n\t--color-primary-2: #3b7ee3;\n\t--color-primary-3: #ccedff;\n\t--color-primary-4: #003c97;\n\t--color-primary-7: #c1daff;\n\t--color-primary-8: #97c1ff;\n\t--color-primary-9: #CCEDFF;\n\t--color-primary-10: #A8E1AE;\n\t--color-primary-11: #a1c4f9;\n\t--color-primary-12: #F5F5F5;\n\t--color-light-2: #E0E0E0;\n\n\n\t--color-error: #e12f2f;\n\t--color-success: #66b032;\n\t--color-green: #569755;\n\t--color-green-2: #92e391;\n\t--color-green-3: #d3eace;\n\t--color-yellow: #e7d788;\n\t--color-yellow-2: #ffc247;\n\t--color-yellow-3: #8f4f00;\n\t--color-light-red: #FFE8E8;\n\t--color-deep-red: #9f0000;\n\t--color-red: #c43c2d;\n\t--color-red-2: #af2415;\n\n\t--color-grey: #b3b3c5;\n\t--color-grey-2: #9898AB;\n\t--color-grey-3: #e0e9f3;\n\t--color-grey-4: #D1D1D1;\n\t--color-grey-5: #EBEBF5;\n\t--color-table-grey: #fafafc;\n\t--color-table-grey-1: #f4f4fc;\n\n\t--color-dark: #4a4a68;\n\t--color-dark-2: #1a1a42;\n\t--color-dark-3: #696365;\n\t--color-dark-4: #60607A;\n\t--color-dark-6: #2a2828;\n\n\t--color-admin: #112855;\n\t--color-admin-2: #071530;\n\t--color-admin-3: #020710;\n\n\t--color-disabled: #C0C0C0;\n\t--color-light-blue: #EBF2FF;\n\t--color-light-blue-2: #D4E5FF;\n\t--color-light-blue-3: #E7F3FE;\n\n\t--color-dark-yellow: #7E6E1F;\n\t--color-light-brown: #f4f5f6;\n\t--color-light-green: #E4FFEC;\n\t--color-light-yellow: #FFF5D7;\n\t--color-light-grey: #F3F3FF;\n\t--color-sell-main: #001432;\n\t--color-sell-2: #5F5F61;\n\n\t--color-moneyex-primary: #25C900;\n\t--color-moneyex-primary-2: #6bf04d;\n\t--color-moneyex-primary-3: #305627;\n\t--color-moneyex-primary-4: #0a2404;\n\n\n\n\t// FONT\n\t--default-font-size: 1.8rem;\n\t--default-font-h1: 6.4rem;\n\t--default-font-h2: 4rem;\n\t--default-font-h3: 3.2rem;\n\t--default-font-subtitle: 2.4rem;\n\t--default-font-medium: 1.6rem;\n\t--default-font-small: 1.4rem;\n\t--default-font-xsmall: 1.2rem;\n}\n\n//COLORS\n$color-light: #f4f9ff;\n$color-white: #ffffff;\n\n$color-primary: #1f68d6;\n$color-primary-2: #3b7ee3;\n$color-primary-3: #ccedff;\n$color-primary-4: #003c97;\n$color-primary-7: #c1daff;\n$color-primary-09: #CCEDFF;\n\n$color-error: #e12f2f;\n$color-success: #66b032;\n$color-green: #569755;\n$color-green-2: #92e391;\n$color-yellow: #e7d788;\n$color-light-red: #f7d1cd;\n\n$color-grey: #b3b3c5;\n$color-grey-2: #d1d1d1;\n$color-grey-3: #e0e9f3;\n$color-grey-4: #D1D1D1;\n\n$color-dark: #4a4a68;\n$color-dark-3: #696365;\n$color-dark-6: #2a2828;\n\n// FONT\n$default-font-size: 1.8rem;\n$default-font-h1: 6.4rem;\n$default-font-h2: 4rem;\n$default-font-h3: 3.2rem;\n$default-font-subtitle: 2.4rem;\n$default-font-small: 1.4rem;\n\n// SHADOWS\n$shadow-dark: 0 2rem 6rem rgba(0, 0, 0, 0.3);\n$shadow-light: 0 2rem 5rem rgba(0, 0, 0, 0.06);","@import '../variables/variables';\n\n.filter {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tmargin-top: 1rem;\n\tfont-size: var(--default-font-small);\n\tposition: relative;\n\tz-index: 10;\n\n\t&>* {\n\t\tmargin-bottom: 2rem;\n\t}\n\n\t&__beside {\n\t\tdisplay: flex;\n\t\tgap: 1rem;\n\t\tposition: absolute;\n\t\ttop: 3rem;\n\t\tleft: 1rem;\n\n\t\t// @media only screen and (max-width: $bp-1000) {\n\t\t// \tposition: relative;\n\t\t// }\n\t}\n\n\t&__by {\n\t\tbackground-color: var(--color-white);\n\t\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\t\tborder-radius: 1rem;\n\t\tpadding: 0 1rem;\n\t\tpadding-bottom: 1rem;\n\t\t// max-width: 19rem;\n\t\theight: fit-content;\n\t\tcolor: var(--color-dark);\n\n\t\t&__list {\n\t\t\tpadding: 1rem 2rem;\n\t\t\tlist-style: none;\n\t\t\tcursor: pointer;\n\n\t\t\t&:hover {\n\t\t\t\tbackground-color: var(--color-grey-3);\n\t\t\t\tborder-radius: 1rem;\n\t\t\t}\n\n\t\t\t&__active {\n\t\t\t\tbackground-color: var(--color-grey-3);\n\t\t\t\tborder-radius: 1rem;\n\t\t\t}\n\t\t}\n\n\n\t}\n\n\t&__action {\n\t\tbackground-color: var(--color-white);\n\t\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\t\tborder-radius: 1rem;\n\t\twidth: 30rem;\n\t\tpadding: 2rem;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\n\t\t&> :not(:last-child) {\n\t\t\tmargin-bottom: 1rem;\n\t\t}\n\n\t\t&__btns {\n\t\t\tdisplay: flex;\n\t\t\tgap: 1rem;\n\t\t}\n\t}\n\n}\n\n.tag {\n\tbackground-color: var(--color-primary-3);\n\tfont-size: var(--default-font-small);\n\theight: 4rem;\n\tpadding: 0.5rem 1rem;\n\tborder-radius: 8px;\n\twidth: 15rem;\n\tmargin-top: 1rem;\n\tmargin-right: 1rem;\n\n\t&_close {\n\t\tdisplay: block;\n\t\tbackground-color: var(--color-dark);\n\t\tcolor: var(--color-white);\n\t\twidth: 16px;\n\t\theight: 16px;\n\t\tline-height: 16px;\n\t\ttext-align: center;\n\t\tborder-radius: 50%;\n\t}\n}\n\n.tags {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\n\t&> :not(:last-child) {\n\t\tmargin-right: 1rem;\n\t}\n}\n\n.singleTag {\n\tdisplay: flex;\n\tfont-size: var(--default-font-small);\n\talign-items: center;\n\tbackground-color: var(--color-grey-5);\n\tpadding: 1rem;\n\tborder-radius: 0.5rem;\n\tcursor: pointer;\n\tmargin-bottom: 0.5rem;\n\n\t&> :not(:last-child) {\n\t\tmargin-right: 0.5rem;\n\t}\n\n\t&> :last-child {\n\t\tfont-size: 2rem;\n\t}\n\n\t&:hover {\n\t\tcolor: var(--color-primary);\n\t}\n\n}\n\n.tagRelative {\n\tposition: relative;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filter": `MimaNewFilter_filter__ieVbl`,
	"filter__beside": `MimaNewFilter_filter__beside__nlElD`,
	"filter__by": `MimaNewFilter_filter__by__TpDNG`,
	"filter__by__list": `MimaNewFilter_filter__by__list__i+wiP`,
	"filter__by__list__active": `MimaNewFilter_filter__by__list__active__DiuYB`,
	"filter__action": `MimaNewFilter_filter__action__TvFi5`,
	"filter__action__btns": `MimaNewFilter_filter__action__btns__yiayd`,
	"tag": `MimaNewFilter_tag__2k1ha`,
	"tag_close": `MimaNewFilter_tag_close__bc4Sb`,
	"tags": `MimaNewFilter_tags__ARQZT`,
	"singleTag": `MimaNewFilter_singleTag__KOa0y`,
	"tagRelative": `MimaNewFilter_tagRelative__R04cG`
};
export default ___CSS_LOADER_EXPORT___;
